import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { TemplateService } from '../../../services/template.service';
import { TranslateService } from '@ngx-translate/core';
var DocumentIssueComponent = (function () {
    function DocumentIssueComponent(route, http, apiService, template, translate, router) {
        this.route = route;
        this.http = http;
        this.apiService = apiService;
        this.template = template;
        this.translate = translate;
        this.router = router;
        this.username = localStorage.getItem('username');
        this.documentTypes = this.template.get().filter(function (doc) {
            return doc.type !== 'tax_invoice' && doc.type !== 'invoice_tax_invoice' &&
                doc.type !== 'delivery_order_tax_invoice' && doc.type !== 'receipt' &&
                doc.type !== 'invoice';
        });
        this.step = 1;
        this.pdfPage = 1;
        this.pdfLoaded = false;
        this.isLoading = false;
    }
    DocumentIssueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.buyerBranchID = params['buyer_branch'];
        });
        this.route.queryParams.subscribe(function (query) {
            if (query.id) {
                if (query.type === 'reissue') {
                    _this.docProcessType = 'reissue';
                    _this.getDocumentTaxDataInfo(query.id);
                }
                else if (query.type === 'request') {
                    _this.docProcessType = 'request';
                    _this.getDocumentRequestInfo(query.id);
                }
            }
            if (query.abbData) {
                _this.getAbbDetail(query.abbData);
            }
        });
    };
    DocumentIssueComponent.prototype.getAbbDetail = function (id) {
        var _this = this;
        this.apiService.getAbbDetail(id).subscribe(function (response) {
            _this.abbData = response;
            var foundTemplate = _this.template.get().find(function (item) { return item.type === 'receipt_tax_invoice'; });
            _this.selectDocumentType(foundTemplate);
        });
    };
    DocumentIssueComponent.prototype.getDocumentRequestInfo = function (id) {
        var _this = this;
        if (!id) {
            return;
        }
        this.apiService.getDocumentRequestInfo(id).subscribe(function (res) {
            _this.documentInformation = res;
            var foundTemplate = _this.template.get().find(function (item) { return item.type === 'receipt_tax_invoice'; });
            _this.selectDocumentType(foundTemplate);
        });
    };
    DocumentIssueComponent.prototype.getDocumentTaxDataInfo = function (id) {
        var _this = this;
        this.apiService.getDocumentTaxDataInfo({ id: id }).subscribe(function (res) {
            _this.documentInformation = res.results[0];
            var foundTemplate = _this.template.get().find(function (item) { return item.type === res.results[0].rd_document_type; });
            _this.selectDocumentType(foundTemplate);
        });
    };
    DocumentIssueComponent.prototype.selectDocumentType = function (type) {
        this.selectedDocumentType = type;
        this.step = 2;
    };
    DocumentIssueComponent.prototype.setPDF = function (pdf) {
        this.pdfPageLength = pdf.numPages;
        this.pdfLoaded = true;
    };
    DocumentIssueComponent.prototype.resetPDF = function () {
        this.pdfLoaded = false;
        this.pdfPage = 1;
        this.pdfError = undefined;
    };
    DocumentIssueComponent.prototype.nextPage = function () {
        if (this.pdfPage < this.pdfPageLength) {
            this.pdfPage++;
        }
    };
    DocumentIssueComponent.prototype.prevPage = function () {
        if (this.pdfPage > 1) {
            this.pdfPage--;
        }
    };
    DocumentIssueComponent.prototype.createETaxInvoice = function () {
        var _this = this;
        this.isLoading = true;
        this.resetPDF();
        this.apiService.createETaxInvoice(this.documentFormData)
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (res) {
            _this.pdfPath = res.pdf_file;
            _this.pdf = {
                url: res.pdf_file,
                httpHeaders: { Authorization: 'Bearer' + ' ' + localStorage.getItem('currentUser') },
                withCredentials: true
            };
            if (!_this.documentFormData.preview) {
                _this.sniff('CREATE_DOC', _this.username);
            }
        }, function (err) {
            var duplicate_branch_name = 'duplicate key value violates unique constraint';
            var errorDetail = err.error;
            if (errorDetail.includes(duplicate_branch_name)) {
                if (errorDetail.includes('tax_data_taxdata_abb_data_id_key')) {
                    _this.pdfError = _this.translate.instant('ISSUE-TEXT.DUPLICATE-ABB');
                }
                else {
                    var detailIndex = errorDetail.indexOf('DETAIL:');
                    if (detailIndex !== -1) {
                        var charactersAfterDetail = errorDetail.substring(detailIndex + 'DETAIL:'.length);
                        _this.pdfError = charactersAfterDetail.trim();
                    }
                }
            }
            else {
                _this.pdfError = err.error;
            }
        });
    };
    DocumentIssueComponent.prototype.previewPDF = function (data) {
        this.documentFormData = data;
        if (this.documentFormData) {
            this.step = 3;
            this.documentFormData['preview'] = true;
            this.createETaxInvoice();
        }
        else {
            this.removeQueryParam();
            this.documentFormData = null;
            this.step = 1;
        }
    };
    DocumentIssueComponent.prototype.removeQueryParam = function () {
        var urlTree = this.router.parseUrl(this.router.url);
        delete urlTree.queryParams['id'];
        delete urlTree.queryParams['type'];
        this.router.navigateByUrl(urlTree);
    };
    DocumentIssueComponent.prototype.editDoc = function () {
        this.step = 2;
        this.pdf = undefined;
        window.scrollTo(0, 0);
    };
    DocumentIssueComponent.prototype.submitDoc = function () {
        this.step = 4;
        this.documentFormData['preview'] = false;
        this.createETaxInvoice();
    };
    DocumentIssueComponent.prototype.startOver = function () {
        this.step = 1;
        this.pdf = undefined;
    };
    DocumentIssueComponent.prototype.print = function () {
        var _this = this;
        this.apiService.getFileFullPath(this.pdfPath).subscribe(function (blob) {
            var rdDocType = _this.documentFormData.file_type;
            var invoiceNumber = _this.documentFormData.invoice_number;
            var issueDt = _this.documentFormData.issue_dt.slice(0, 10).replace(/-/gi, '_');
            var fileName = invoiceNumber + "_" + rdDocType + "_" + issueDt + ".pdf";
            _this.apiService.createDownloadFile(blob, fileName);
            _this.sniff('CLICK_PRINT', _this.documentFormData.invoice_number);
        }, function (error) {
            console.log(error);
        });
    };
    DocumentIssueComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'DOC_ISSUE',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    return DocumentIssueComponent;
}());
export { DocumentIssueComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/document-issue.component.ts.pre-build-optimizer.js